import { render } from "./LocksView.vue?vue&type=template&id=2195db56"
import script from "./LocksView.vue?vue&type=script&lang=js"
export * from "./LocksView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__